import {stores} from '../../store';

export function redirectBack(location) {
  if (location && location.state && location.state.prevPage) {
    stores.uiStore.setPageTitle(location.state.prevPage);
  }
  stores.routerStore.goBack();
}
